import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { Assets } from '@Utils/AssetsStore';

export const PRODUCT_SUBTITLE_MARGIN_TOP = 15;
export const PRODUCT_SUBTITLE_HEIGHT = 82 - PRODUCT_SUBTITLE_MARGIN_TOP;

export const DISPLACE_GAP = 35;

export const PRODUCT_SUBTITLE_TEXT: Omit<CardTextProps, 'text'> = {
  color: 'black',
  fontSize: 14,
  lineHeight: 17 / 14,
  letterSpacing: 0.03,
  fontAsset: Assets.Font_Gilroy_SemiBold,
};

export const PRODUCT_SUBTITLE_TEXT_MOBILE: Omit<CardTextProps, 'text'> = {
  color: 'black',
  fontSize: 12,
  lineHeight: 14 / 12,
  letterSpacing: 0.03,
  fontAsset: Assets.Font_Gilroy_SemiBold,
};
